/* DocumentCreate Messages
 *
 * This contains all the text for DocumentCreate component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  saveDocumentSuccess: {
    id: 'app.containers.DocumentCreate.saveDocumentSuccess',
    defaultMessage: 'Document has been successfully created.',
  },
  saveDocumentFailure: {
    id: 'app.containers.DocumentCreate.saveDocumentFailure',
    defaultMessage: 'Error. The document could not be created.',
  },
  title: {
    id: 'app.containers.DocumentCreate.title',
    defaultMessage: 'Create document',
  },
  currentFolder: {
    id: 'app.containers.DocumentCreate.currentFolder',
    defaultMessage: 'Current folder',
  },
  rootFolder: {
    id: 'app.containers.DocumentCreate.rootFolder',
    defaultMessage: 'Root folder',
  },
  saveButton: {
    id: 'app.containers.DocumentCreate.saveButton',
    defaultMessage: 'Save',
  },
});
